export default {
  colors: {
    black: '#222',
    // background: '#FFFCEA',
    background: '#FFFFFF',
    // section: '#EDE7D3',
    section: '#EEEEEE',
    // interaction: '#FFAE55',
    interaction: '#5AFF78',
    interactionInactive: '#ddd',
    darkgray: '#888',
    darkBackground: '#3D3D3D',
    warning: '#dd8080'
  },
  fonts: {
    sans: 'Roboto, sans-serif',
    mono: 'Roboto Mono, monospace'
  }
};
